<div *ngIf="isLoading && !isError" class="floating-container">
    <mat-spinner class="floating-spinner"></mat-spinner>
</div>
<div *ngIf="!isLoading && !isError">
    <mat-toolbar class="bar-filler"></mat-toolbar>
    <div class="small-margin"> 
        <mat-form-field class="fill-parent-width">
            <mat-label>{{'Pages.EditProfile.FullName' | translate}}</mat-label>
            <input matInput type="text" autocomplete="off" [(ngModel)]="fullName" name="fullName">
        </mat-form-field>
        <mat-form-field class="fill-parent-width">
            <mat-label>{{'Pages.EditProfile.Phone' | translate}}</mat-label>
            <input matInput type="tel" autocomplete="off" [(ngModel)]="phone" name="phone">
        </mat-form-field>
    </div>
    <div class="small-margin small-padding">
        <button class="fill-parent-width" mat-button (click)="seePrivacyPolicy()">{{'Pages.EditProfile.PrivacyButton' | translate}}</button>
        <div style="height: 15px;"></div>
        <button *ngIf="edit === false" class="fill-parent-width" mat-flat-button color="accent" (click)="save()">{{'Pages.EditProfile.CreateProfile' | translate}}</button>
        <button *ngIf="edit === true" class="fill-parent-width" mat-flat-button color="accent" (click)="save()">{{'Pages.EditProfile.SaveProfile' | translate}}</button>
    </div>
    <mat-toolbar class="bar-filler"></mat-toolbar>
    <mat-toolbar color="primary" class="top-bar">
        <button mat-icon-button (click)="back()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <div>{{'Pages.EditProfile.Title' | translate}}</div>
    </mat-toolbar>
</div>
<div *ngIf="isError" class="floating-container">
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{'Errors.ConectionError.Title' | translate}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <p>{{'Errors.ConectionError.Message' | translate}}</p>
          </mat-card-content>
          <mat-card-actions>
            <button mat-raised-button color="accent" class="fill-parent-width" (click)="tryAgain()">{{'Errors.ConectionError.Button' | translate}}</button>
          </mat-card-actions>
    </mat-card>
</div>